// extracted by extract-css-chunks-webpack-plugin
module.exports = {"spinner":"spinner__spinner___XTSca","spinner-rotating":"spinner__spinner-rotating___qL3Fs","spinnerRotating":"spinner__spinner-rotating___qL3Fs"};
    if(module.hot) {
      // 1771211541121
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  